import { render } from "./addNormal.vue?vue&type=template&id=633c77b6&scoped=true"
import script from "./addNormal.vue?vue&type=script&lang=js"
export * from "./addNormal.vue?vue&type=script&lang=js"

import "./addNormal.vue?vue&type=style&index=0&id=633c77b6&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-633c77b6"]])

export default __exports__